<script setup lang="ts">
    const hexa = defineModel<string>({ default: '#000000' });

    function updateHexa(newHexa: string) {
        hexa.value = newHexa;
    }
</script>

<template>
    <input
        :aria-label="$t('colorpicker_aria_hexadecimal_value')"
        data-test="hex-value"
        class="border-theme-background h-8 w-full rounded-md border text-center"
        :value="hexa"
        @change="updateHexa(($event.target as HTMLInputElement).value)"
    />
</template>
